import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { LoginService } from '../../../app/service/login/login.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'home',
  templateUrl: './home.html',
  styleUrls: ['./home.scss']
})

export class HomePage { 

  greetings
	isDesktop
	userName
	cards = [
	  {
      title: 'Consulta de Plan Protection',
      subtitle: 'Consulta de PP',
      color: 'white',
      url: 'pp/consulta',
      bgStyle : 'purple',
      background: 'rgb(20 137 72)',
      icon:'fa-magnifying-glass'
	  },
	  
	  {
      subtitle: 'Trámite de PP',
      title:'Plan Protection en Trámite',
      color: 'white',
      url: 'pp/en-tramite',
      bgStyle : 'primary',
      background: 'rgb(224 116 50)',
      icon:'fa-pen-to-square'
	  },

	//   {
    //   subtitle:'KPIs de PP',
    //   title: 'Indicadores de Plan Protection',
    //   color: 'white',
    //   url: 'pp/kpis',
    //   bgStyle : 'warning',
    //   background: 'rgb(229, 206, 11)',
    //   icon:'fa-chart-line'
	//   },
   
	  
	]
	
  
	constructor(private router: Router, private loginService: LoginService, private dialog: MatDialog){
	  this.isDesktop = window.innerWidth > 780 ? true : false
	  this.setGreetings()
	  this.userName = localStorage.getItem('userName')
	//   if(localStorage.getItem('first_access') === '1'){
	// 	this.seleccionarSucursal()
	//   }
	}
	
	getUser = ()=> { 
		return this.loginService.getVariableSesion('firstName') + ' ' + this.loginService.getVariableSesion('lastName') 
	}
  
	setGreetings(){
	  const hourDay = +moment(new Date()).format("HH");
		  if (hourDay >= 5 && hourDay < 12) {
			this.greetings = "Buenos días "
		  } else if (hourDay >= 12 && hourDay < 20) {
			this.greetings = "Buenas tardes "
		  } else if ((hourDay >= 20 && +hourDay < 24) || (hourDay >= 0 && +hourDay < 5)) {
			this.greetings = "Buenas noches "
		  }
	}
  
	irA(seccion){
	  this.router.navigate([seccion])
	}
  
}
